export enum ApplicationState {
    UNKNOWN,
    UNAUTHENTICATED,
    UNVERIFIED,
    AUTHENTICATED,
    APPROVED
}  